"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var bytes_serialiser_1 = require("./../serialisers/bytes-serialiser");
var replace_licence_response_serialiser_1 = require("./../services/replace-licence/replace-licence-response-serialiser");
exports.UPDATE_LICENSE = {
    id: 159,
    request: bytes_serialiser_1.BytesSerialiser,
    response: replace_licence_response_serialiser_1.ReplaceLicenceResponseSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/replace-license-services.js
// module id = 1377
// module chunks = 1